import axios, { AxiosRequestConfig, AxiosError } from "axios";

interface ApiOptions {
  config: AxiosRequestConfig;
}

interface ApiResponse<T = any> {
  data: T | null;
  error: { message: string } | null;
}

export const callExternalApi = async <T = any>(options: ApiOptions): Promise<ApiResponse<T>> => {
  try {
    const response = await axios(options.config);
    const { data } = response;

    return {
      data,
      error: null,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      const { response } = axiosError;

      let message = "http request failed";

      if (response && response.statusText) {
        message = response.statusText;
      }

      if (axiosError.message) {
        message = axiosError.message;
      }

      if (response && response.data && (response.data as any).message) {
        message = (response.data as any).message;
      }

      return {
        data: null,
        error: {
          message,
        },
      };
    }

    return {
      data: null,
      error: {
        message: (error as Error).message,
      },
    };
  }
};